import { clear as userClear } from "actions/user";
import { clear as jobsClear } from "actions/jobs";
import { put, takeLeading } from "redux-saga/effects";
import * as keys from "constants/keys";

function* execute() {
    localStorage.removeItem(keys.AccessTokenKey);
    yield put(jobsClear());
    yield put(userClear());
    yield put({
        type: "com.sage.actions.balance.IClear",
    } as sage.actions.balance.IClear);
    yield put({
        type: "com.sage.actions.file.IClear",
    } as sage.actions.file.IClear);
    yield put({
        type: "com.sage.actions.team.IClear",
    } as sage.actions.team.IClear);
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.user.ISignOut", execute);
}
